enum CallCenterUserConnectionState {
    Disconnected = "Disconnected",
    Connected = "Connected",
    Connecting = "Connecting"
}

export { CallCenterUserConnectionState };
